<template>
  <div>
    <div v-for="(group, index) in groups" :key="index">
      <h2 class="section-title m-4 text-center text-lg">{{ $t(group.label) }}</h2>
      <div id="courseList">
        <ul class="courselist pl-4">
          <li v-for="course in courses(group).slice(0, group.maxCourses)" :key="course.id">
            <div class="course">
              <div class="course-info">
                <h3 class="course-title">
                  {{ course.title }}
                </h3>
                <img v-lazy="course.image" class="course-image" />
                <p class="course-detail" v-html="course.detail"></p>
              </div>
              <div class="course-button m-4">
                <a class="button-primary block" v-on:click="showModal(course)">
                  {{ $t('tour_display_detail_label') }}
                </a>
              </div>
            </div>
          </li>
          <li v-if="courses(group).length > group.maxCourses">
            <div class="course">
              <div class="course-info">
                <h3 class="course-title text-white">*</h3>
                <div class="text-center text-gray-500 px-5">
                  <a @click="addCourse(group)">{{ $t('tour_add_model_cource_title') }}</a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <CourseModal v-show="modal.show" :closeModal="() => closeModal()">
      <CourseDetail :course="course" @createItem="createItem" />
    </CourseModal>
  </div>
</template>

<script>
import CourseModal from "../molecules/CourseModal"
import CourseDetail from '../molecules/CourseDetail'

export default {
  name: 'CourseList',
  components: {
    CourseModal,
    CourseDetail
  },
  data () {
    return {
      course: {},
      modal: {
        show: false
      },
      groups: [
        {
          label: 'tour_model_cource_north_title',
          areas: [
            "青森",
            "秋田",
            "岩手"
          ],
          maxCourses: 1000
        },
        {
          label: 'tour_model_cource_south_title',
          areas: [
            "山形",
            "宮城",
            "福島"
          ],
          maxCourses: 1000
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('courses/fetchAll')
      .then(() => {
        this.$store.dispatch('loading/endLoading')
      })
  },
  methods: {
    showModal (course) {
      this.course = course
      this.modal.show = true
    },
    closeModal () {
      this.modal.show = false
    },
    createItem (courseId) {
      // GoogleAnalytics
      this.$gtag.event("コースからプラン作成", {
        course_name: this.course.title
      });
      
      this.$router.push({ name: 'newPlan', query: { courseId: courseId } })
    },
    addCourse (group) {
      group.maxCourses += 10
    },
    courses (group) {
      var course = []
      const courses = this.$store.getters['courses/getAll']
      for (let i = 0; i < courses.length; i++) {
        if (group.areas.indexOf(courses[i].area) !== -1) {
          course.push(courses[i])
        }
      }
      return course
    }
  }
}
</script>
